export default __webpack_public_path__ + "4dfea0b149c4a5beba96c8186629d3ba.svg";